var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"search-box"},[_c('dev-choose')],1),_c('div',{staticClass:"relation-table"},[_c('relation-table-list')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }